import { render, staticRenderFns } from "./Complexes.vue?vue&type=template&id=4f158c96&"
import script from "./Complexes.vue?vue&type=script&lang=js&"
export * from "./Complexes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports